module.exports = __webpack_public_path__ + "static/will.9d8a7790.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/will.webp
// module id = 170
// module chunks = 0